import request from "@/utils/request";

// ---------------------------------------------------意见与建议-----------------------------------
// 提交意见与建议
export function suggestData(data) {
  return request({
    url: "/web/suggest/submit",
    method: "post",
    data: data,
  });
}

// -------------------------------------------首页------------------------------
// 网站标题和系统logo
export function webSiteData() {
  return request({
    url: "/web/config/get",
    method: "get",
  });
}

// 头部展开、收缩、热点
export function advertisement() {
  return request({
    url: "/web/advertisement/getList",
    method: "get",
  });
}

// 首页tab
export function tabGetList() {
  return request({
    url: "/web/column/getList",
    method: "get",
  });
}

// 地区tab
export function regionSort() {
  return request({
    url: "/web/article/regionSort",
    method: "get",
  });
}

// 首页文章
export function getHomeArticlePage(params) {
  return request({
    url: "/web/article/page",
    method: "get",
    params,
    headers: {
      isToken: params.isToken,
    },
  });
}

// 文章详情
export function getArticleDetail(val) {
  let _id = "";
  let _isToken = false;
  if (typeof val == "number") {
    _id = val;
  } else {
    let { id, isToken } = val;
    _id = id;
    _isToken = isToken;
  }

  return request({
    url: `/web/article/detail/${_id}`,
    method: "get",
    headers: {
      isToken: _isToken,
    },
  });
}

// 生态应用
export function application(params) {
  return request({
    url: "/web/application/list",
    method: "get",
    params,
  });
}

// -------------------------------------肺功能----------------------------------

// 获取验证码
export function sendSiteCode(data) {
  return request({
    url: `/sendSiteCode?mobile=${data}`,
    method: "post",
  });
}

// 登录
export function Login(data) {
  return request({
    url: `/siteLogin`,
    method: "post",
    data,
  });
}

// 查询网站获取栏目下所涉及到的设备类型
export function getDeviceKind(params) {
  return request({
    url: `/web/article/getDeviceKind`,
    method: "get",
    params,
  });
}
